import React, { useEffect, useState } from 'react';
import { Project } from '../types';
import SkillCard from '../components/SkillCard';
import ProjectCard from '../components/ProjectCard';
import './Portfolio.css';

const Portfolio: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/data/projects.json')
      .then((res) => res.json())
      .then((data) => setProjects(data))
      .catch((err) => console.error('Failed to load projects:', err));
  }, []);

  return (
    <div className="portfolio-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <p className="hero-greeting">Hi, I'm</p>
          <h1 className="hero-name">Srinidhi M</h1>
          <h2 className="hero-title">Developer Engineer</h2>
          <p className="hero-description">
            I build robust backend systems, AI-powered applications, and scalable cloud infrastructure.
            Passionate about Python, Node.js, and everything in between.
          </p>
          <div className="hero-cta">
            <a
              href="https://github.com/srinidhim2"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button primary"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" />
              </svg>
              GitHub
            </a>
          </div>
        </div>
        <div className="hero-visual">
          <div className="code-block">
            <div className="code-header">
              <span className="dot red"></span>
              <span className="dot yellow"></span>
              <span className="dot green"></span>
            </div>
            <pre className="code-content">
              <code>
{`{
  "name": "Srinidhi M",
  "role": "Developer Engineer",
  "skills": [
    "Python", "Node.js",
    "FastAPI", "Django",
    "Docker", "K8s", "AWS"
  ],
  "interests": [
    "AI/ML", "Backend",
    "System Design"
  ]
}`}
              </code>
            </pre>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <SkillCard />

      {/* Projects Section */}
      <section className="projects-section">
        <h2 className="section-title">
          <span className="title-accent">#</span> Projects
        </h2>
        <div className="projects-grid">
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
        {projects.length === 0 && (
          <p className="empty-state">No projects yet. Add them to /public/data/projects.json</p>
        )}
      </section>
    </div>
  );
};

export default Portfolio;
